<template>
  <div class="row selectionContent">
    <div class="col-sm-12">
      <h4 class="info-text text-center">
        Select your account type
      </h4>

      <p class="f-size-14"></p>
    </div>
    <div class="col-sm-12">
      <div class="inputGroup">
        <input
          id="radio1"
          name="radio"
          type="radio"
          value="personal"
          v-model="accountType"
        />
        <label for="radio1">Personal</label>
      </div>
      <div class="inputGroup">
        <input
          id="radio2"
          name="radio"
          type="radio"
          value="business"
          v-model="accountType"
        />
        <label for="radio2">Business</label>
      </div>
    </div>
    <div class="col-sm-12 mt-3 clearfix" v-if="accountType">
      <input
        type="button"
        class="btn btn-fill btn-success btn-block btn-wd btn-md"
        name="continue"
        value="continue"
        @click.prevent="next()"/>
    </div>
  </div>
</template>
<script>
export default {
  name: "AccountType",
  data() {
    return {
      accountType: "",
    };
  },
  methods: {
    next() {
        if (this.accountType=="personal"){
            //redirect to application form
            this.$router.push({ name: "Home" });
        }else{
             window.location.href =
                      "https://www.smartcurrencybusiness.com/open-an-account/";
        }
    },
  },
};
</script>

<style scoped lang="scss">
.selectionContent {
  display: flex;
  padding: 0 16px;
  font-size: 18px;
  font-weight: 600;
  line-height: 36px;
}
.inputGroup {
  background-color: #fff;
  display: block;
  margin: 10px 0;
  width: 100%;

  label {
    padding: 12px 30px;
    width: 100%;
    display: block;
    text-align: left;
    color: #3c454c;
    cursor: pointer;
    position: relative;
    z-index: 2;
    transition: color 200ms ease-in;
    overflow: hidden;

    &:before {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      content: "";
      background-color: #5562eb;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale3d(1, 1, 1);
      transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
      opacity: 0;
      z-index: -1;
    }

    &:after {
      width: 32px;
      height: 32px;
      content: "";
      border: 2px solid #d1d7dc;
      background-color: #fff;
      background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
      background-repeat: no-repeat;
      background-position: 2px 3px;
      border-radius: 50%;
      z-index: 2;
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      transition: all 200ms ease-in;
    }
  }

  input:checked ~ label {
    color: #fff;

    &:before {
      transform: translate(-50%, -50%) scale3d(56, 56, 1);
      opacity: 1;
    }

    &:after {
      background-color: #54e0c7;
      border-color: #54e0c7;
    }
  }

  input {
    width: 32px;
    height: 32px;
    order: 1;
    z-index: 2;
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    visibility: hidden;
  }
}
</style>
